import { render } from "./theme30.vue?vue&type=template&id=3b7b9e55&scoped=true"
import script from "./theme30.vue?vue&type=script&lang=js"
export * from "./theme30.vue?vue&type=script&lang=js"

import "./theme30.vue?vue&type=style&index=0&id=3b7b9e55&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-3b7b9e55"

export default script